<template>
  <div>
    <form @submit.prevent="speak">
      <label for="text">Text:</label>
      <input class="form-control" id="text" type="text" v-model="text" required>
      <button type="submit" class="btn btn-success">GO</button>
    </form>

     <form @submit.prevent="setApp">
      <label for="app">WS App:</label>
      <input class="form-control" id="app" type="text" v-model="app" required>
      <button type="submit" class="btn btn-success">GO</button>
    </form>
   <div class="error" v-if="error.length > 0">{{error}}</div>
   <!-- <button v-on:click="clickButton" v-html="buttonDescription()"></button> -->
   <!-- <button v-on:click="pushNotification()">Notification</button> -->
  </div>
</template>

<script>
import Websocket from '../mixins/Websocket'
import EventBus from '../bus'

export default {
  name: 'start',
  mixins: [Websocket],
  data () {
    return {
      wss: 'parker2020.daniel@gmail.com',
      token: 'TK9x103qGyD4Tp3AKSSo74J43JTOT0',
      error: '',
      text: '',
      selectedVoice: 0,
      synth: window.speechSynthesis,
      voiceList: [],
      app: 'TextToSpeak',
      greetingSpeech: new window.SpeechSynthesisUtterance()
    }
  },
  created: function () {
    var lsApp = localStorage.getItem('App')
    if (lsApp) {
      this.app = lsApp
    }
  },
  mounted: function () {
    this.voiceList = this.synth.getVoices()

    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices()
    }
    const self = this
    EventBus.$on('wsMessage', function (payLoad) {
      console.log('payLoad')
      console.log(payLoad)
      if (payLoad.textToSpeak) {
        console.log('textToSpeak')
        self.text = payLoad.textToSpeak
        self.speak()
      }
    })
    this.speak()
  },
  methods: {
    setApp () {
      localStorage.setItem('App', this.app)
      const sendData = { app: this.app }
      this.wsSend(sendData)
    },
    speak () {
      console.log('speak')
      console.log(this.text)
      this.greetingSpeech.text = `${this.text}`
      console.log(this.synth)
      console.log(this.greetingSpeech)
      if (this.voiceList[2]) {
        this.greetingSpeech.voice = this.voiceList[2]
        this.synth.speak(this.greetingSpeech)
      }
    },
    buttonDescription () {
      return (this.timerActiv) ? 'Clear Timer' : 'Set Timer'
    },
    clickButton () {
      if (!this.timerActiv) {
        var self = this
        this.timer = setInterval(function () {
          self.pushNotification()
        }, 10000)
      } else {
        clearInterval(this.timer)
      }
      this.timerActiv = !this.timerActiv
    },
    pushNotification () {
      if (Notification.permission === 'granted') {
        console.log('PUSH NOTIFICATION')
        navigator.serviceWorker.getRegistration().then(function (reg) {
          if (reg) {
            reg.showNotification('Neuer Termin', {
              body: 'Ein neuer Termin steht an!',
              icon: '../../static/img/icons/android-chrome-192x192.png',
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: 'vibration-sample'
            })
          }
        })
      }
    },
    getTimeMin () {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
      var yyyy = today.getFullYear()
      // 2020-02-29T00:00:00Z
      return yyyy + '-' + mm + '-' + dd + 'T00:00:00Z'
    },
    getStart (item) {
      const d = new Date(item.start.dateTime)
      const dt = d.toLocaleString().replace(',', '').split(' ')
      const date = dt[0].split('.')
      const time = dt[1].split(':')
      return this.weekday[d.getDay()] + ' ' + this.pad_2(date[0]) + '. ' + this.months[date[1]] + ' um ' + time[0] + ':' + time[1] + 'Uhr'
    },
    pad_2 (number) {
      return (number < 10 ? '0' : '') + number
    }
  },
  watch: {
    websocketIsConnected (newValue) {
      // An websocket mit app anmelden
      if (newValue) {
        console.log('melde mich an')
        const sendData = { app: this.app }
        this.wsSend(sendData)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* @font-face { 
  font-family: "JERSEY"; 
  src: url("../../static/fonts/JerseyM54-aLX9.ttf"); 
} */

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}

.event p{
  margin: 4px 0;
  text-align: left;
}
.event {
  font-size: 0.9rem;
  border-bottom: 1px solid #35495E;
  padding: 10px 0;
}
.error {
  margin: 2px 0;
  text-align: left;
}

button {
  margin: 10px;
}

.start {
  /* font-style: italic; */
  font-weight: bold;
  /* font-family: "JERSEY", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 2px;
  position: relative; */
}

/* .start span {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
  position: absolute;
  top: 0;
} */

.location {
  display: flex;
}

.location img {
  margin-right: 4px;
}



</style>




// WEBPACK FOOTER //
// src/components/Start.vue